import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap"
import ReactApexChart from "react-apexcharts";
import '../style/style.css'
import { TbPoint, TbPointFilled } from "react-icons/tb";
import Loader3 from '../../../../../../CommonElements/Spinner/loader3'
import { useNavigate } from 'react-router';
import { errorToast } from '../../../../../../_helper/helper';

export default function HeatmapForArea({ heatmapData, moduleLength, loader, filters, AreaDashboard }) {
  const navigate = useNavigate();
  console.log('vvvvvvvvv', filters)
  const [series, setseries] = useState([
    {
      name: 'Person Available Alert',
      data: [40, 10, 3,]
    },
    {
      name: 'Grouping',
      data: [50, 15, 7,]
    },
    {
      name: 'No Go Area',
      data: [0, 0, 0,]
    },
    {
      name: 'Machine Visiting',
      data: [0, 0, 0,]
    },
    {
      name: 'Machine Guard',
      data: [1, 6, 10,]
    },
    {
      name: 'Supervisor Presence',
      data: [6, 10, 4,]
    },


  ])

  const options = {
    chart: {
      type: 'heatmap',
      width: '100%',  // Responsive width
      toolbar: {
        show: false
      },
      events: {
        dataPointSelection: function (event, chartContext, { dataPointIndex, seriesIndex, w }) {
          try {
            console.log("Data point clicked");
            const value = w.globals.series[seriesIndex][dataPointIndex];

            // Skip navigation if value is -1 (N/A)
            if (value === -1) {
              console.log("This data point is not available");
              return;
            }

            // Get the subarea from the new data structure
            const subArea = heatmapData?.sub_area?.[dataPointIndex] || '';

            // Get the model name (y-axis value)
            const yAxisValue = chartContext.w.config.series[seriesIndex]?.name || '';

            // For x-axis value, we'll use the area name from user data or a default
            const areaName = JSON.parse(localStorage.getItem('userData'))?.area_ids?.name || 'Unknown Area';

            console.log('Area:', areaName);
            console.log('Model:', yAxisValue);
            console.log('Subarea:', subArea);
            console.log('Value:', value);
            console.log('Filters:', filters);

            // Store in localStorage
            localStorage.setItem('xAxisValue', JSON.stringify(areaName));
            localStorage.setItem('yAxisValue', JSON.stringify(yAxisValue));
            localStorage.setItem('subValue', JSON.stringify(subArea));
            localStorage.setItem('heatmapfilters', JSON.stringify(filters));

            const role = JSON.parse(localStorage.getItem('role'));
            navigate(`${process.env.PUBLIC_URL}/dashboard/default/alerts/${role}`);
          } catch (error) {
            console.error("Error in dataPointSelection:", error);
            errorToast('Something went wrong');
          }
        },
      },
      background: '#fff',
      fontFamily: 'inherit',
      // Add responsive array to handle specific configurations under 800px
      responsive: [{
        breakpoint: 800,
        options: {
          chart: {
            width: 600  // Set minimum width at this breakpoint
          },
          xaxis: {
            labels: {
              style: {
                fontSize: '10px'  // Reduce font size for labels under 800px
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '10px'  // Reduce font size for labels under 800px
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '10px'  // Reduce font size for data labels under 800px
            }
          }
        }
      }]
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px',
        fontWeight: 100,
        colors: ['#1e293b'],

      }
    },
    xaxis: {
      // Use sub_area from the new heatmapData structure
      categories: (heatmapData?.sub_area || [])?.map((subarea) => {
        // Format subarea names to be more readable
        return subarea.charAt(0).toUpperCase() + subarea.slice(1);
      }),
      labels: {
        style: {
          fontSize: '12px'
        },
        rotate: -45,
        rotateAlways: false,
        trim: true,
        maxHeight: 120
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },


    yaxis: {
      // categories: ['Vest', 'Helmet'],
      categories: (heatmapData?.data || [])?.map(item => item?.name),
      labels: {
        style: {
          fontSize: '12px',
        }
      }
    },
    plotOptions: {
      heatmap: {
        enableShades: false,
        shadeIntensity: 0.5,
        distributed: true,
        radius: 10,
        padding: 5,
        colorScale: {
          ranges: [
            {
              from: -1,
              to: -1,
              name: ' ',
              color: '#f6f6f6',
              foreColor: '#f6f6f6'
            },
            {
              from: 0,
              to: 0,
              name: '',
              color: '#54ba4a',
              foreColor: '#ffffff',
            },
            // {
            //   from: filters?.month ? 1 : 1,
            //   to: filters?.month ? 4 : 1,
            //   name: 'Normal',
            //   color: '#54ba4a',
            //   foreColor: '#000000'
            // },
            // {
            //   from: filters?.month ? 5 : 2,
            //   to: filters?.month ? 8 : 2,
            //   name: 'Serious',
            //   color: '#86ADE9',
            //   foreColor: '#000000'
            // },
            {
              from: filters?.month ? 1 : 1,
              to: filters?.month ? 16 : 4,
              name: 'Trouble',
              color: '#ffaa05',
              foreColor: '#ffffff',
            },
            {
              from: filters?.month ? 17 : 5,
              to: filters?.month ? 160000000000 : 60000000,
              name: 'Critical',
              color: '#e42618', // Color for all values >= 31
              foreColor: '#ffffff'
            }
          ]
        }
      }
    },

    grid: {
      show: false
    },
    legend: {
      show: false
    },
    tooltip: {
      enabled: true,
      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const value = w.globals.series[seriesIndex][dataPointIndex];
        const subarea = heatmapData?.sub_area?.[dataPointIndex] || 'Unknown';
        const modelName = heatmapData?.data?.[seriesIndex]?.name || 'Unknown';

        // Handle special values
        if (value === -1) {
          return `<div class="custom-tooltip" style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div style="font-weight: bold; margin-bottom: 4px;">${modelName}</div>
                    <div style="font-size: 12px; color: #666;">Subarea: ${subarea}</div>
                    <div style="font-size: 12px; color: #666;">Status: N/A</div>
                  </div>`;
        } else if (value === 0) {
          return `<div class="custom-tooltip" style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div style="font-weight: bold; margin-bottom: 4px;">${modelName}</div>
                    <div style="font-size: 12px; color: #666;">Subarea: ${subarea}</div>
                    <div style="font-size: 12px; color: #666;">Alerts: ${value}</div>
                  </div>`;
        } else {
          return `<div class="custom-tooltip" style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div style="font-weight: bold; margin-bottom: 4px;">${modelName}</div>
                    <div style="font-size: 12px; color: #666;">Subarea: ${subarea}</div>
                    <div style="font-size: 12px; color: #666;">Alerts: ${value}</div>
                  </div>`;
        }
      },
      theme: 'light'
    }
    // tooltip: {
    //   enabled: true,
    //   custom: function({ seriesIndex, dataPointIndex, w }) {
    //     const value = w.globals.series[seriesIndex][dataPointIndex];
    //     const areaName = heatmapData?.areaOwner[dataPointIndex];

    //     // Only show tooltip if value is greater than 0
    //     if (value > 0) {
    //       return `<div class="custom-tooltip">
    //                 <span><strong>${value}</strong> <span style="font-size:10px;font-weight:lighter">
    //                 alerts</span></span><br/>
    //                 <span>${areaName}</span>
    //               </div>`;
    //     }
    //     return false; // This will hide the tooltip when value is 0 or less
    //   },
    //   theme: 'light',
    //   x: {
    //     show: true
    //   }
    // }
  }
  const options2 = {
    chart: {
      type: 'heatmap',
      width: '100%',  // Responsive width
      toolbar: {
        show: false
      },
      events: AreaDashboard ? {
        dataPointSelection: function (event, chartContext, { dataPointIndex, seriesIndex, w }) {
          try {
            console.log("Data point clicked");
            const value = w.globals.series[seriesIndex][dataPointIndex];

            // Skip navigation if value is -1 (N/A)
            if (value === -1) {
              console.log("This data point is not available");
              return;
            }

            // Get the subarea from the new data structure
            const subArea = heatmapData?.sub_area?.[dataPointIndex] || '';

            // Get the model name (y-axis value)
            const yAxisValue = chartContext.w.config.series[seriesIndex]?.name || '';

            // For x-axis value, we'll use the area name from user data or a default
            const areaName = JSON.parse(localStorage.getItem('userData'))?.area_ids?.name || 'Unknown Area';

            console.log('Area:', areaName);
            console.log('Model:', yAxisValue);
            console.log('Subarea:', subArea);
            console.log('Value:', value);
            console.log('Filters:', filters);

            // Store in localStorage
            localStorage.setItem('xAxisValue', JSON.stringify(areaName));
            localStorage.setItem('yAxisValue', JSON.stringify(yAxisValue));
            localStorage.setItem('subValue', JSON.stringify(subArea));
            localStorage.setItem('heatmapfilters', JSON.stringify(filters));

            const role = JSON.parse(localStorage.getItem('role'));
            navigate(`${process.env.PUBLIC_URL}/dashboard/default/alerts/${role}`);
          } catch (error) {
            console.error("Error in dataPointSelection:", error);
            errorToast('Something went wrong');
          }
        },
      } : null,

      background: '#fff',
      fontFamily: 'inherit',
      responsive: [{
        breakpoint: 800,
        options: {
          chart: {
            width: 600
          },
          xaxis: {
            labels: {
              style: {
                fontSize: '10px'
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '10px'
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '10px'
            }
          }
        }
      }]
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px',
        fontWeight: 100,
        colors: ['#1e293b'],

      }
    },
    xaxis: {
      // Use sub_area from the new heatmapData structure
      categories: (heatmapData?.sub_area || [])?.map((subarea) => {
        // Format subarea names to be more readable
        return subarea.charAt(0).toUpperCase() + subarea.slice(1);
      }),
      labels: {
        style: {
          fontSize: '12px'
        },
        rotate: -45,
        rotateAlways: false,
        trim: true,
        maxHeight: 120
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },


    yaxis: {
      // categories: ['Vest', 'Helmet'],
      categories: (heatmapData?.data || [])?.map(item => item?.name),
      labels: {
        style: {
          fontSize: '12px',
        }
      }
    },
    plotOptions: {
      heatmap: {
        enableShades: false,
        shadeIntensity: 0.5,
        distributed: true,
        radius: 10,
        padding: 5,
        colorScale: {
          ranges: [
            {
              from: -1,
              to: -1,
              name: ' ',
              color: '#f6f6f6',
              foreColor: '#f6f6f6'
            },
            {
              from: 0,
              to: 0,
              name: '',
              color: '#54ba4a',
              foreColor: '#ffffff',
            },
            // {
            //   from: filters?.month ? 1 : 1,
            //   to: filters?.month ? 4 : 1,
            //   name: 'Normal',
            //   color: '#54ba4a',
            //   foreColor: '#000000'
            // },
            // {
            //   from: filters?.month ? 5 : 2,
            //   to: filters?.month ? 8 : 2,
            //   name: 'Serious',
            //   color: '#86ADE9',
            //   foreColor: '#000000'
            // },
            {
              from: filters?.month ? 1 : 1,
              to: filters?.month ? 16 : 4,
              name: 'Trouble',
              color: '#ffaa05',
              foreColor: '#ffffff',
            },
            {
              from: filters?.month ? 17 : 5,
              to: filters?.month ? 160000000000 : 60000000,
              name: 'Critical',
              color: '#e42618', // Color for all values >= 31
              foreColor: '#ffffff'
            }
          ]
        }
      }
    },
    grid: {
      show: false
    },
    legend: {
      show: false
    },
    tooltip: {
      enabled: true,
      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const value = w.globals.series[seriesIndex][dataPointIndex];
        const subarea = heatmapData?.sub_area?.[dataPointIndex] || 'Unknown';
        const modelName = heatmapData?.data?.[seriesIndex]?.name || 'Unknown';

        // Handle special values
        if (value === -1) {
          return `<div class="custom-tooltip" style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div style="font-weight: bold; margin-bottom: 4px;">${modelName}</div>
                    <div style="font-size: 12px; color: #666;">Subarea: ${subarea}</div>
                    <div style="font-size: 12px; color: #666;">Status: N/A</div>
                  </div>`;
        } else if (value === 0) {
          return `<div class="custom-tooltip" style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div style="font-weight: bold; margin-bottom: 4px;">${modelName}</div>
                    <div style="font-size: 12px; color: #666;">Subarea: ${subarea}</div>
                    <div style="font-size: 12px; color: #666;">Alerts: ${value}</div>
                  </div>`;
        } else {
          return `<div class="custom-tooltip" style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    <div style="font-weight: bold; margin-bottom: 4px;">${modelName}</div>
                    <div style="font-size: 12px; color: #666;">Subarea: ${subarea}</div>
                    <div style="font-size: 12px; color: #666;">Alerts: ${value}</div>
                  </div>`;
        }
      },
      theme: 'light'
    },
  }

  // We're now using the new heatmapData structure with sub_area and data properties


  // const items = [
  //   { label: 'Normal', color: '#dde8f9', width: '74px', height: '5px', borderRadius: '5px' },
  //   { label: 'Serious', color: '#86ADE9', width: '58px', height: '5px', borderRadius: '5px' },
  //   { label: 'Trouble', color: '#1e67d6', width: '42px', height: '5px', borderRadius: '5px' },
  //   { label: 'Critical', color: '#164b9c', width: '26px', height: '5px', borderRadius: '5px' },

  const items = [
    { label: 'Normal', color: '#54ba4a', width: '74px', height: '5px', borderRadius: '5px', hoverText: `${filters?.month ? '0 Alerts' : '0 Alert'}` },
    // { label: 'Serious', color: '#86ADE9', width: '58px', height: '5px', borderRadius: '5px', hoverText:`${filters?.month ? '5 To 8 Alerts': '2 Alerts'}` },
    { label: 'Trouble', color: '#ffaa05', width: '42px', height: '5px', borderRadius: '5px', hoverText: `${filters?.month ? '1 To 16 Alerts' : '3 To 4 Alerts'}` },
    { label: 'Critical', color: '#e42618', width: '26px', height: '5px', borderRadius: '5px', hoverText: `${filters?.month ? '17 And Above' : '5 And Above'}` },
    { label: 'N/A', color: '#f6f6f6', width: '18px', height: '5px', borderRadius: '5px', padding: true, hoverText: 'Not Available' },
  ];

  useEffect(() => {
    // Set the series data from the heatmapData
    setseries(heatmapData?.data);

    // Log the heatmap data for debugging
    console.log("HeatmapForArea data structure:", {
      subareas: heatmapData?.sub_area,
      data: heatmapData?.data,
      fullData: heatmapData
    });


  }, [heatmapData])


  return (
    <Card style={{ minHeight: '300px', borderRadius: '32px' }}>

      <CardHeader className='pb-0' style={{ border: '0px', borderTopLeftRadius: '32px', borderTopRightRadius: '32px' }}>
        <h5 >Area Intensity Heatmap</h5>
      </CardHeader>
      {loader ? <div className='w-100 h-100 d-flex justify-content-center align-items-center position-absolute ' style={{ height: '100%' }}><Loader3 /></div> :
        <CardBody className='pt-0'>
          <Row >
            <Col >
              <div className='colorShadeOfheatMap' style={{ display: 'flex', flexDirection: 'column', gap: '10px', minWidth: '205px' }}>

                {/* {items.map((item, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                    <TbPointFilled size={40} style={{ color: item.color }} />
                    <span style={{ fontSize: '14px', color: '#6c757d' }}>{item.label}</span>
                  </div>
                ))} */}
                {items.map((item, index) => (

                  <div
                    key={index}
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                    className="tooltip-wrapper"
                  >
                    {/* Tooltip */}
                    {
                      item?.hoverText && <div className="tooltip">
                        {item.hoverText}
                      </div>
                    }


                    {/* Dot */}
                    <TbPointFilled size={40} style={{ color: item.color }} />

                    {/* Label */}
                    <span style={{ fontSize: '14px', color: '#6c757d' }}>{item.label}</span>
                  </div>
                ))}

              </div>
            </Col>
            <Col xs='12' className='heatmapnewdesign' style={{ overflowX: 'auto' }}>
              <div style={{ minWidth: '600px' }}>
                <ReactApexChart
                  options={AreaDashboard ? options2 : options}
                  series={series}
                  type="heatmap"
                  height="350px"
                />
                <p className='text-center'>Alerts</p>
              </div>
            </Col>

          </Row>

        </CardBody>
      }

    </Card>
  )
}